<template>
    <div class="newDetail">
        <header class="header">
            <h3>企业资讯</h3>
            <el-breadcrumb class="fl" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>关于橙蟹</el-breadcrumb-item>
                <el-breadcrumb-item>企业资讯</el-breadcrumb-item>
                <el-breadcrumb-item>详情</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button class="fr return" type="info" @click="ret()">返回</el-button>
        </header>
        <main class="main" ref="main">

        </main>
    </div>
</template>

<script>
    import { getCompanyNewsById } from '../api/api.js'
    export default {
        name: 'companyNewsDetail',
        mounted() {
            getCompanyNewsById({ id: this.$route.params.id }).then(res => {
                if (res.data.status === 1) {
                    this.$refs.main.innerHTML = res.data.data.content
                } else {

                }
            })
        },
        data() {
            return {
                state: true
            }
        },
        methods: {
            ret() {
                if (this.$route.params.path == 1) {
                    this.$router.back(-1);
                } else {
                    this.$router.push({ path: '/about/qyzx' })
                }
            },
        }
    }
</script>


<style scoped>
    .header {
        width: 70%;
        padding: 3% 15%;
        background-color: #2e324f;
        color: #ffffff;
        font-size: 24px;
        position: relative;
    }

    .main {
        width: 70%;
        padding: 4% 15%;
        background-color: #f5f5f5;
    }

    .return {
        position: absolute;
        top: 50px;
        right: 280px;
    }
</style>



// WEBPACK FOOTER //
// src/components/companyNewsDetail.vue